export enum MapChallengeMode {
    // ?
    TheStonevault = 501,

    // WotLK
    PitOfSaron = 556,

    // Cataclysm
    GrimBatol = 507,
    TheStonecore = 541,

    // Warlords of Draenor
    Skyreach = 161,

    // Legion
    SeatOfTheTriumvirate = 239,

    // Battle for Azeroth
    KingsRest = 249,
    TempleOfSethraliss = 250,

    // Dragonflight
    AlgetharAcademy = 402,
    BrackenhideHollow = 405,
    DawnOfTheInfiniteGalakrondsFall = 463,
    DawnOfTheInfiniteMurozondsRise = 464,
    HallsOfInfusion = 406,
    Neltharus = 404,
    RubyLifePools = 399,
    TheAzureVault = 401,
    TheNokhudOffensive = 400,

    // The War Within
    AraKara = 503,
    CinderbrewMeadery = 506,
    CityOfThreads = 502,
    DarkflameCleft = 504,
    EcoDomeAldani = 542,
    OperationFloodgate = 525,
    PrioryOfTheSacredFlame = 499,
    TheDawnbreaker = 505,
    TheRookery = 500,

    // Midnight
    AltarOfFangs = 588,
    DenOfNalorakk = 586,
    MagistersTerrace = 558,
    MaisaraCaverns = 560,
    MurderRow = 587,
    NexusPointXenas = 559,
    TheBlindingVale = 584,
    VoidscarArena = 585,
    WindrunnerSpire = 557,
}
